import { FunctionComponent, useEffect } from "react";
import { CheckIcon, CloseIcon } from "@form/components/common/icons";
import useAccount from "@/hooks/useAccount";
import useVerifyClaim from "@/hooks/useVerifyClaim";
import { TwitterIcon } from "@form/components/common/icons";
import useUserTwitter from "@/form/hooks/useUserTwitter";
import { confirm } from "@form/services/modal";

const TwitterVerify: FunctionComponent = () => {
  const { isLogin, login } = useAccount();
  const { result, changeVerifyState } = useVerifyClaim("account_twitter");

  const verifyed = result["account_twitter"];

  const { twitter, connect, connecting, authLink, disconnect } =
    useUserTwitter();

  const isConnected = !!twitter && isLogin;

  useEffect(() => {
    changeVerifyState(isConnected);
  }, [isConnected]);

  return (
    <div className="flex items-center bg-white/70 rounded-lg py-4 px-7 select-none">
      <CheckIcon
        className={`w-5 h-5 ${verifyed ? "fill-green" : ""}`}
      ></CheckIcon>
      <TwitterIcon className="fill-twitter ml-2 w-5 h-5"></TwitterIcon>
      <div className="text-sm font-semibold text-dark1 ml-1">Twitter</div>
      <div className="flex-1"></div>
      {isConnected ? (
        <div className="flex items-center">
          <span className="text-gray1 text-sm select-text">
            @{twitter?.username}
          </span>
          <div
            className="action ml-1 w-[14px] h-[14px] rounded-full bg-primary flex items-center justify-center"
            onClick={() => {
              confirm({
                title: "Are you sure to disconnect your account?",
                okText: "Disconnect",
                okType: "danger",
                onOk() {
                  disconnect();
                },
              });
            }}
          >
            <CloseIcon className="w-[6px]"></CloseIcon>
          </div>
        </div>
      ) : (
        <a
          rel="noreferrer"
          href={authLink}
          className="font-semibold text-sm text-primary hover:text-primary"
          target="_blank"
          onClick={(e) => {
            if (!isLogin) {
              login();
              e.preventDefault();
              return false;
            }
            if (!authLink) {
              e.preventDefault();
              return false;
            }
            connect();
          }}
        >
          Connect
        </a>
      )}
    </div>
  );
};

export default TwitterVerify;
